<template>
    <div class="enter-cabinet-header">
        <h3 class="def-title-3">
            <span :class="{'enter__active': activeTab==='enter'}" class="enter__title">
                {{ authData.messages.login_cabinet }}
            </span>
            <span :class="{'enter__active': activeTab==='registration'}" class="enter__title">
                {{ authData.messages.register_m }}
            </span>
        </h3>
        <!--            Авторизация с помощью социальных сервисов-->
        <div v-if="authData.auth_services.length>0" class="enter-cabinet__socials-wrap">
            <p>{{ messages.social }}</p>
            <div class="socials">
                <div v-for="service in authData.auth_services" class="form-vertical">
                    <a :href="'javascript:'+service.jsEvent"

                       class="form-vertical__social"
                    >
                        <svg v-if="service.icon === 'facebook'">
                            <use xlink:href="#svg-facebook-new"></use>
                        </svg>
                        <svg v-else>
                            <use xlink:href="#svg-google-new"></use>
                        </svg>

                    </a>
                </div>

            </div>
            <p>{{ messages.or }}</p>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'enter-cabinet-header',
    computed: {
        ...mapState({
            authData: ({ personal }) => personal.data,
            messages: ({ personal }) => personal.data?.messages,
            activeTab: ({ personal }) => personal.data?.activeTab,
        }),
    },
}
</script>

<style lang="scss" scoped>
    .enter-cabinet{
        &__socials-wrap {
            text-align: center;
            margin-bottom: 26px;
        }
        p{
            color: #85898B;
            text-transform: uppercase;
            font-size: 11px;
            font-weight: 500;
        }
        &-header{
            display: flex;
            flex-direction: column;
            align-items: center;
            /*margin-bottom: 26px;*/

            .socials{
                display: flex;
                justify-content: center;
            }
            .def-title-3 {
                font-size: rem(16);
                margin-bottom: 20px;
                @include point-lg {
                    //font-size: rem(16);
                }

                & > *:not(.enter__active) {
                    display: none;
                }
            }
        }
    }
    .socials{
        margin-top: 10px;
        margin-bottom: 25px;
    }
    .form-vertical{
        margin: 0 15px;

        &__social{
            svg{
                display: block;
                width: 18px;
                height: 18px;
            }
        }
    }

</style>